import Link from 'next/link'
import { Checkbox } from '@/components/ui/checkbox'
import { Heading } from '@/components/ui/heading'
import { Label } from '@/components/ui/label'
import { Text } from '@/components/ui/text'
import { useTermsOfService } from './useTermsOfService'

type Props = {
  title: string
  status?: string
  description: string
  downloadSelect: React.ReactNode
}

export function DownloadCard({ title, status, description, downloadSelect }: Props) {
  const { accepted, setAccepted } = useTermsOfService()

  return (
    <div className="bg-rock-1">
      <div className="flex flex-col px-[20px] py-[20px]">
        <div className="flex justify-between items-center gap-[10px] pb-[10px]">
          <Heading size="h5" className="pb-1">
            {title}
          </Heading>
          {status && (
            <div className="relative border border-olive-2/30 px-2">
              <Label className="text-dark/70 uppercase font-medium">{status}</Label>
            </div>
          )}
        </div>
        <Text className="pb-3" color="subtle" size="sm">
          {description}
        </Text>
        <div className="flex flex-col gap-2">
          <div className="flex items-center flex-1 gap-1">
            <Checkbox
              aria-label="Acept the Terms of Service"
              onCheckedChange={(checked) => setAccepted(!!checked)}
              checked={accepted}
            />
            <Text
              size="xs"
              className="font-diatype flex items-center gap-1 text-ellipsis"
              onClick={() => setAccepted(!accepted)}
            >
              I accept the{' '}
              <Link
                href="/terms-of-service"
                target="_blank"
                className="text-punch hover:underline"
                onClick={(e) => {
                  e.stopPropagation()
                }}
              >
                Terms of Service
              </Link>
            </Text>
          </div>
          {downloadSelect}
        </div>
      </div>
    </div>
  )
}
